import type { ComponentPropsWithoutRef } from 'react';

export const NavCard = ({ className = '', ...props }: ComponentPropsWithoutRef<'div'>) => (
  <div
    className={`block text-center rounded-lg bg-background shadow-[0_1px_2px_1px_theme(colors.base-200)] [&_.button]:w-full ${className}`}
    {...props}
  />
);

export const HorizontalSwoosh = ({ className = '', ...props }: ComponentPropsWithoutRef<'svg'>) => (
  <svg className={`absolute -bottom-px left-0 right-0 sm:landscape:hidden md:hidden ${className}`} {...props} />
);

export const VerticalSwoosh = ({ className = '', ...props }: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    className={`absolute left-0 -top-px h-[calc(100%+2px)] hidden sm:landscape:block md:block ${className}`}
    {...props}
  />
);

export const Hero = ({ className = '', ...props }: ComponentPropsWithoutRef<'div'>) => (
  <div
    className={`sm:landscape:flex sm:landscape:flex-row-reverse md:flex md:flex-row-reverse ${className}`}
    {...props}
  />
);

export const Media = ({ className = '', ...props }: ComponentPropsWithoutRef<'div'>) => (
  <div
    className={`
      relative overflow-hidden h-[200px]
      min-[430px]:h-[250px]
      min-[500px]:h-[300px]
      sm:h-[370px]
      sm:landscape:w-[55%] sm:landscape:h-[250px]
      md:w-[55%] md:h-[300px]
      lg:h-[400px]
      xl:h-[500px]
      ${className}
    `}
    {...props}
  />
);

export const Content = ({ className = '', ...props }: ComponentPropsWithoutRef<'div'>) => (
  <div
    className={`
      py-2 pb-[60px] text-center
      prose prose-headings:mx-auto prose-headings:leading-tight
      sm:prose-sm sm:prose-headings:mx-auto
      lg:prose-lg
      xl:prose-xl
      sm:landscape:w-[45%] sm:landscape:pl-[50px] sm:landscape:flex sm:landscape:items-center sm:landscape:text-left sm:landscape:prose-headings:mx-0
      md:w-[45%] md:pl-[50px] md:flex md:items-center md:text-left md:prose-headings:mx-0
      ${className}
    `}
    {...props}
  />
);

export const NavItems = ({ className = '', ...props }: ComponentPropsWithoutRef<'div'>) => (
  <div
    className={`
      px-3
      [&>div>div:nth-child(1)_.card]:-mt-5
      md:[&>div>div:nth-child(1)_.card]:-mt-10
      lg:[&>div>div:nth-child(1)_.card]:-mt-[60px]
      sm:[&>div>div:nth-child(2)_.card]:-mt-5
      md:[&>div>div:nth-child(2)_.card]:-mt-10
      lg:[&>div>div:nth-child(2)_.card]:-mt-[60px]
      xl:[&>div>div.column>div.card]:-mt-[100px]
      ${className}
    `}
    {...props}
  />
);

export const Container = ({ className = '', ...props }: ComponentPropsWithoutRef<'div'>) => (
  <div
    className={`
      px-3 mx-auto
      sm:max-w-[540px]
      md:max-w-[720px]
      lg:max-w-[960px]
      xl:max-w-[1224px]
      ${className}
    `}
    {...props}
  />
);
